import { APPLICANT_ATTENTION_ACTION_KEY } from '../../RentalPortalApplicantProfile.constants'

export const APPLICANT_ATTENTION_DESTINATION = {
  approve: 'approve',
  moveToScreening: 'moveToScreening',
  recordVerdict: 'recordVerdict',
}

export const APPLICANT_ATTENTION_ACTION_DESTINATION = {
  [APPLICANT_ATTENTION_ACTION_KEY.approve]:
    APPLICANT_ATTENTION_DESTINATION.approve,
  [APPLICANT_ATTENTION_ACTION_KEY.moveToScreening]:
    APPLICANT_ATTENTION_DESTINATION.moveToScreening,
  [APPLICANT_ATTENTION_ACTION_KEY.recordVerdict]:
    APPLICANT_ATTENTION_DESTINATION.recordVerdict,
}

export const APPLICANT_ATTENTION_FULL_PAGE_ONLY_DESTINATIONS = [
  APPLICANT_ATTENTION_DESTINATION.approve,
  APPLICANT_ATTENTION_DESTINATION.recordVerdict,
]
